export default __webpack_public_path__ + "media/images/maestro-ae4aa991fb8bc64d235c5d70fa5d4175.svg";